module.exports = __webpack_public_path__ + "static/img/6.b70ab04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shao/6.jpg
// module id = uMbc
// module chunks = 1